import jQuery from 'jquery';

(function($) {
  $.fn.serializeObject = function() {
    var o = {};
    var a = this.serializeArray().filter(field => field.value.length > 0);

    const $form = this;

    $.each(a, function() {
      const $input = $form.find(`input[name=${this.name}]`);

      let value;
      const dv = $input.attr('data-value');
      if (dv != null && dv.length > 0) {
        value = dv;
      } else {
        value = this.value;
      }

      if (o[this.name] !== undefined) {
        if (!o[this.name].push) {
          o[this.name] = [o[this.name]];
        }
        o[this.name].push(value || '');
      } else {
        o[this.name] = value || '';
      }
    });

    var $radio = $('input[type=radio],input[type=checkbox]', this);
    $.each($radio, function() {
      const name = this.name || $(this).attr('rel');
      if (!this.checked) {
        o[name] = 'off';
      } else {
        o[name] = 'on';
      }
    });

    return o;
  };
})(jQuery);

const getFilterForm = () => jQuery('.filters form, .search form');

const isInputEmpty = (_, element) => jQuery(element).val().length === 0;

export default () => {
  const $form = getFilterForm();

  // Dropdown
  $form.find('.ui.dropdown').dropdown({
    onChange: () => $form.submit(),
  });

  $form.find('.ui.checkbox').each((_, element) => {
    const $target = jQuery(element).find('input[type="checkbox"]');
    const rel = $target.attr('rel');

    if (rel && rel.length) {
      $target.after(
        `<input type="hidden" name="${rel}" value="${$target.val()}" />`
      );
    }
  });

  // Checkbox
  $form.find('.ui.checkbox').on('change', event => {
    const $target = jQuery(event.target);

    $target.next('input[type="hidden"]').val($target.val());

    $form.submit();
  });

  // Search icon
  $form.find('i.search').on('click', () => $form.submit());

  // Reset
  $form.find('button.reset').on('click', () => {
    $form
      .find('input, select')
      .not(':button, :submit, :reset')
      .attr('disabled', 'disabled');

    $form.submit();
  });

  // Submit (ignore empty parameters)
  $form.on('submit', event => {
    jQuery(event.target)
      .find('input[name], select[name]')
      .filter(isInputEmpty)
      .attr('name', '');
  });
};

export function getCurrentFilters(): any {
  return getFilterForm().serializeObject();
}



// WEBPACK FOOTER //
// ./src/plugins/search.js